module.exports = __webpack_public_path__ + "img/white-x-icon.af31cfca.svg";